import { useMutation, useQueryClient } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { BaseResponse, BroadcastMessagePayload } from "../schemas/messaging";

import { queryKeyPrefix } from "./useGetConversations";

export const usePostBroadcastMessage = () => {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation<BaseResponse, Error, BroadcastMessagePayload>({
    mutationFn: args => client.postBroadcastMessage(args),
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeyPrefix);
    },
  });
};
